import jscookie from 'js-cookie'
import { AUTH_API_COOKIE } from '../modules/user'

const state = {
	//roomBucket: null,
}

const mutations = {
/*	setRoomBucket(state, payload) {
		state.roomBucket = payload
	},*/
}

const actions = {
	// fetches all Amenities Lists.  
	//If roomKey is provided in payload, the list is return sorted with lists being used by this room at the top
	fetchAmenitiesListOfLists ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action: fetchAmenitiesListOfLists ", payload)
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomAmenities/fetchListOfAmenitiesLists',
			 {
                        headers: {
                        'database' : getters.getDatabase(),
                        'Content-Type': 'application/json',
                        'apiEsriToken': apiEsriToken,
                        'impersonate' : getters.impersonateID,
                        },
                        method: "POST",
                        body: JSON.stringify(payload)
                })
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
		  })
	},

	
	// Fetch One Amenities List.  If roomKey is provided, the list will return with values for the room.
	fetchAmenitiesList ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action: fetchAmenitiesList ", payload)
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomAmenities/fetchAmenitiesList',
			 {
                        headers: {
                        'database' : getters.getDatabase(),
                        'Content-Type': 'application/json',
                        'apiEsriToken': apiEsriToken,
                        'impersonate' : getters.impersonateID,
                        },
                        method: "POST",
                        body: JSON.stringify(payload)
                })
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
		  })
	},

	updateRoomAmenitiesList ({getters}, payload) {		
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action: updateAmenitiesList ", payload)
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/roomAmenities/updateRoomAmenitiesList",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken': apiEsriToken,
                        	'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		})
	},

	updateAmenitiesListDefinition ({getters}, payload) {		
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action: updateAmenitiesList ", payload)
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/roomAmenities/updateAmenitiesListDefinition",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken': apiEsriToken,
                        	'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		})
	},

	createAmenitiesList ({getters}, payload) {		
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: createAmenitiesList ", payload)
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/roomAmenities/createAmenitiesList",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken': apiEsriToken,
                        	'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		})
	},

	deleteAmenitiesList ({getters}, payload) {		
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: deleteAmenitiesList ", payload)
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/roomAmenities/deleteAmenitiesList",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken': apiEsriToken,
                        	'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		})
	},

	clearRoomAmenitiesData ({getters}, payload) {		
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: clearRoomAmenitiesData ", payload)
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/roomAmenities/clearRoomAmenitiesData",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken': apiEsriToken,
                        	'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		})
	},

	fetchAmenityListRoomData ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action: fetchAmenitiesListOfLists ", payload)
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/search/roomAmenityList',
			 {
                        headers: {
                        'database' : getters.getDatabase(),
                        'Content-Type': 'application/json',
                        'apiEsriToken': apiEsriToken,
                        'impersonate' : getters.impersonateID,
                        },
                        method: "POST",
                        body: JSON.stringify(payload)
                })
		      .then(response => response.json())
		      .then(data => {
		        resolve(data)
		      })
		  })
	},

	clearRoomAmenitiesDataSingleRoom ({getters}, payload) {		
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: clearRoomAmenitiesDataSingleRoom ", payload)
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/roomAmenities/deleteRoomAmenitiesList",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken': apiEsriToken,
                        	'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		})
	},

}

const getters = {
/*	getDept: state => () => {
		return state.room.pct[deptSelectedIndex];
	}*/
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/amenities.js